import {
	Component, ChangeDetectionStrategy, Input, Output, EventEmitter, TemplateRef, OnChanges, SimpleChanges,
} from '@angular/core';
import {ISelectionBoxItem} from "../../../interfaces/Iselection.box.item";
import {ISelectionBoxActionEvent} from "../../../interfaces/Iselection.box.action.event";
import {IconEnum} from "../../../../icon.button/interfaces/icon.enum";
import {MarkOperator} from "../../../../../services/mark.service";

@Component({
	selector: 'cp-sb-selection-list',
	templateUrl: './selection.list.html',
	styleUrls: ['./selection.list.scss'],
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class SelectionListComponent implements OnChanges{

	@Input() data: ISelectionBoxItem[];
	@Input() subTitle:string;
	@Input() itemTemplate: TemplateRef<any>;
	@Input() searchTerms: string[];

	@Output() selectItem: EventEmitter<ISelectionBoxItem> = new EventEmitter<ISelectionBoxItem>();
	@Output() actionClick: EventEmitter<ISelectionBoxActionEvent> = new EventEmitter<ISelectionBoxActionEvent>();
	@Output() subTitleClick = new EventEmitter();

	public markOperator = MarkOperator;

	public onSelect(item: ISelectionBoxItem) {
		this.selectItem.emit(item);
	}

	ngOnChanges(changes: SimpleChanges): void {
//		console.log(changes["data"].currentValue);
	}

	public onActionClick(e, item:ISelectionBoxItem, action:IconEnum){
		e.stopPropagation();
		this.actionClick.emit({item:item, action:action});
	}

	public onSubTitleClick(){
		this.subTitleClick.emit(null);
	}

	public trackByCode(index: number, item: ISelectionBoxItem) {
		return item.code;
	}
}
